function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "iconfinder_icons_new_1564516",
  transform: "translate(-2 -1)"
}, React.createElement("g", {
  id: "new",
  transform: "translate(2 1)"
}, React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  d: "M13.625,6.25A1.857,1.857,0,0,1,11.75,4.375V1.75A.709.709,0,0,0,11,1H5A3.009,3.009,0,0,0,2,4V14.5a3.009,3.009,0,0,0,3,3h9a3.009,3.009,0,0,0,3-3V7a.709.709,0,0,0-.75-.75ZM11,13H6.5a.75.75,0,0,1,0-1.5H11A.75.75,0,0,1,11,13Zm1.5-3h-6a.75.75,0,0,1,0-1.5h6a.75.75,0,0,1,0,1.5Z",
  transform: "translate(-2 -1)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 16.5,
    viewBox: "0 0 15 16.5"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/orders.607d3dbc.svg";
export { SvgComponent as ReactComponent };